import React from 'react'
import './VolunteeredEarlier.css'

function VolunteeredEarlier() {
  return (
    <div className='volunteeredEarlier'>

    </div>
  )
}

export default VolunteeredEarlier